/** Folder names stay kebab-case while public message namespaces follow camelCase contracts. */
export function featureNamespaceFromDirectory(directory: string): string {
  return directory.replace(/-([a-z0-9])/gu, (_, letter: string) => letter.toUpperCase())
}

/** Resolve a public camelCase namespace back to its feature folder. */
export function featureDirectoryFromNamespace(namespace: string): string {
  return namespace.replace(/[A-Z]/gu, (letter) => `-${letter.toLowerCase()}`)
}
